import LoginView from "../views/LoginView.vue";
import ResendEmailView from "../views/ResendEmailView.vue";
import LogoutView from "../views/LogoutView.vue";
import ChangePasswordView from "../views/ChangePasswordView.vue";
import ForgottenPasswordView from "../views/ForgottenPasswordView.vue";
import ResetPasswordView from "../views/ResetPasswordView.vue";
import EditProfileView from "../views/EditProfileView.vue";
import RegisterView from "../views/RegisterView.vue";
//----------------------------
// routes
//----------------------------
export default [
    {
    path: "/",
    name: "loginView",
    component: LoginView,
    meta: { title: "", requiresAuth: false },
  },
  {
    path: "/login",
    name: "loginView",
    component: LoginView,
    meta: { title: "", requiresAuth: false },
  },
  {
    path: "/logout",
    name: "logoutView",
    component: LogoutView,
    meta: { title: "", requiresAuth: false },
  },
  {
    path: "/resend-email",
    name: "resendEmailView",
    component: ResendEmailView,
    meta: { title: "", requiresAuth: false },
  },
  {
    path: "/change-password",
    name: "changePasswordView",
    component: ChangePasswordView,
    meta: { title: "Change Password", requiresAuth: true },
  },
  {
    path: "/forgotten-password",
    name: "forgottenPasswordView",
    component: ForgottenPasswordView,
    meta: { title: "Forgotten Password", requiresAuth: false },
  },
  {
    path: "/reset-password/:url_id/:url_token",
    props: true,
    name: "resetPasswordView",
    component: ResetPasswordView,
    meta: { title: "Reset Password", requiresAuth: false },
  },
  {
    path: "/edit-profile",
    name: "editProfileView",
    component: EditProfileView,
    meta: { title: "Edit Profile", requiresAuth: true },
  },
  {
    path: "/register",
    name: "registerView",
    component: RegisterView,
    meta: { title: "", requiresAuth: false },
  },
];
